
import { Component, Prop, Vue } from 'vue-property-decorator';
import { OpenAccountMetadataOption } from '../../../store/openAccount/types';

@Component
export default class CPOptionDropdown extends Vue {
  @Prop({ required: false })
  public readonly label?: string;

  @Prop({ required: false, default: null })
  public readonly value!: OpenAccountMetadataOption | null;

  @Prop({ required: true })
  public readonly options!: readonly OpenAccountMetadataOption<any>[];

  @Prop({ required: false, default: 'Please Select' })
  public readonly placeholder!: string;

  @Prop({ required: false, default: false })
  public readonly disabled!: boolean;

  @Prop({ required: false, default: false })
  public readonly testId!: string;

  @Prop({ required: false, default: null })
  public readonly error!: string | null;

  @Prop({ required: false, default: null })
  public readonly name!: string;

  public handleChange(value: string | number): void {
    this.$emit(
      'input',
      this.options.find(
        (option) => option.value.toString() === value.toString(),
      ),
    );

    if (this.name) {
      this.$store.commit('clearFieldError', this.name);
    }
  }
}
